import { FlashMessagesService } from './../../shared/flash-messages/service/flash.messages.service';
import { MultiAgency } from './../../shared/models/multi-agency';
import { MultiAgencyService } from './../../shared/multi-agency/multi-agency.service';
import { UpdateStatusPopupComponent } from './update-status-popup/update-status-popup.component';

import { OnInit, Component, ViewChild, OnDestroy } from '@angular/core';
import { MenuStore } from '../../menus/service/menu.store';
import { UserLocalStorageService } from '../../permission/services/user.local.storage.service';
import { DashboardFilterState } from '../dashboard/dashboard-page/dashboard-filter';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { User } from '../../auth/models/User';
import { EventStore } from 'app/event/service/event.store';
import { AgencyDashboardService } from '../service/agency-dashboard.http.service';
import {
  DashboardAll,
  Lastmodified,
  Message,
  Overview,
  OverviewRequest,
  Status,
  StatusRequest,
  TodoListRequest,
  Todolist,
} from '../models/dashboard/agency-dashboard';
import { BulkAction } from '../models/bulk-action';
import { BulkActionPopupComponent } from '../bulk-action/bulk-action-popup/bulk-action-popup.component';
import { EventSearchParametersStore } from '../service/event-search-parameters.store';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'pioneer-agency-dashboard',
  templateUrl: './agency-dashboard.component.html',
  styleUrls: ['./agency-dashboard.component.css'],
})
export class AgencyDashboardComponent implements OnInit, OnDestroy {
  user: User;

  messages: Message[];
  overview: Overview;
  dataAll: DashboardAll;
  todolist: Todolist[];
  lastmodified: Lastmodified[];
  status: Status[];

  statusSelected = 'all';
  headerSelected = 'all';

  agencyCode = '';
  showOverviewCard = '';
  updateDate: Date;

  defaultAgency$: Observable<MultiAgency> = this.multiAgencyService.defaultAgency$;
  agencySubscription$: Subscription = new Subscription();

  constructor(
    private menuStore: MenuStore,
    private userLocalStorageService: UserLocalStorageService,
    private authenticationStore: AuthenticationStore,
    private eventStore: EventStore,
    private agencyDashboardService: AgencyDashboardService,
    private multiAgencyService: MultiAgencyService,
    private eventSearchParametersStore: EventSearchParametersStore,
    private flashMessagesService: FlashMessagesService,
    private route: ActivatedRoute
  ) {}

  get username() {
    return {
      username: this.user.firstName,
    };
  }

  ngOnInit(): void {
    this.updateDate = new Date();

    this.menuStore.setPageHeader('DASHBOARD.TITLE', false);

    this.eventStore.resetSelectedEvent();

    this.authenticationStore.user.subscribe((user: User) => {
      this.user = user;
    });

    this.multiAgencyService.defaultAgencyId.subscribe((agencyId: string) => {
      this.agencyCode = agencyId;
    });

    this.agencySubscription$ = this.defaultAgency$.subscribe(() => {
      this.resetDashboard();
    });
    this.showOverviewCard = this.route.snapshot.queryParams['showOverviewCard'];
    // this.initDashboard();
  }

  initDashboard() {
    this.agencyDashboardService.getAll(this.agencyCode).subscribe(
      (result: DashboardAll) => {
        if (result != null) {
          this.updateDate = new Date();
          this.dataAll = result;
          this.messages = this.dataAll.body.messages;
          this.messages.forEach((element) => {
            element.closed = false;
          });
          this.overview = this.dataAll.body.overview;
          this.overview.tot_comm_amt_str = this.roundAmounts(
            this.overview.tot_comm_amt
          );
          this.overview.tot_pmt_amt_str = this.roundAmounts(
            this.overview.tot_pmt_amt
          );
          this.todolist = this.dataAll.body.todolist;
          this.lastmodified = this.dataAll.body.lastmodified;
          this.status = this.dataAll.body.status;
        }
      },
      (err: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.AGENCY_DASHBOARD_API_ERROR',
          `Error code: ${err.status}`
        );
      }
    );
  }
  roundAmounts(amount: number) {
    if (amount > 1000000) {
      let rounded = this.round(amount / 1000000, 2);
      return rounded + 'M';
    }
    if (amount > 1000) {
      let rounded = this.round(amount / 1000, 2);
      return rounded + 'K';
    }
    return '' + amount;
  }

  round(num: number, fractionDigits: number): number {
    return Number(num.toFixed(fractionDigits));
  }

  onStatusSelectChange(timeframe) {
    this.status = undefined;
    this.agencyDashboardService.getStatus(this.agencyCode, timeframe).subscribe(
      (result: StatusRequest) => {
        if (result != null) {
          this.status = result.body;
        }
      },
      (err: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.AGENCY_DASHBOARD_API_ERROR',
          `Error code: ${err.status}`
        );
      }
    );
  }
  onHeaderSelectChange(timeframe) {
    this.overview = undefined;
    // this.todolist = undefined;
    this.agencyDashboardService
      .getOverview(this.agencyCode, timeframe)
      .subscribe(
        (result: OverviewRequest) => {
          if (result != null) {
            this.overview = result.body;
            this.overview.tot_comm_amt_str = this.roundAmounts(
              this.overview.tot_comm_amt
            );
            this.overview.tot_pmt_amt_str = this.roundAmounts(
              this.overview.tot_pmt_amt
            );
          }
        },
        (err: any) => {
          this.flashMessagesService.error(
            'MESSAGES.ERROR.AGENCY_DASHBOARD_API_ERROR',
            `Error code: ${err.status}`
          );
        }
      );
  }
  onAgencyChange(code) {
    this.overview = undefined;
    this.todolist = undefined;
    this.status = undefined;
    this.dataAll = undefined;
    this.lastmodified = undefined;
    this.messages = undefined;
    this.agencyCode = code;
    this.statusSelected = 'all';
    this.headerSelected = 'all';
    this.initDashboard();
  }

  closedBulkActionModal(event: any) {
    this.resetDashboard();
  }

  resetDashboard() {
    this.overview = undefined;
    this.todolist = undefined;
    this.status = undefined;
    this.dataAll = undefined;
    this.lastmodified = undefined;
    this.messages = undefined;
    this.initDashboard();
  }

  get BulkAction() {
    return BulkAction;
  }

  navigateToSearch(): void {
    this.eventSearchParametersStore.resetWithArchived(true);

    this.eventSearchParametersStore.updateUrl(true);
  }

  ngOnDestroy() {
    this.agencySubscription$.unsubscribe();
  }

  public showOverview(): boolean {
    if (this.showOverviewCard === 'true') {
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/agency-dashboard.component.ts